var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-body"},[_c('div',{staticClass:"row mt-5 mr-2 ml-2 justify-content-md-center"},[(!_vm.initialize)?_c('h2',[_vm._v("Initializing App ...")]):_vm._e(),(
          _vm.initialize && (_vm.hasAccount || _vm.keyExpired || !_vm.getTaskCurrentTaskType)
        )?_c('h2',[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()]),_c('keep-alive',[(_vm.initialize)?_c(_vm.getTaskCurrentTaskType,{tag:"component",attrs:{"link-info":_vm.linkInfo}}):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }